// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3kqlx","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3ihlQ"};